
import { initCaptcha, execute as executeCaptcha } from './_recaptcha';


const isVisible = (elem) => !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
const validateRadios = function(name) {
	const elements = document.querySelectorAll(`[name=${name}]`);
	const visibleElements = Array.from(elements).filter(isVisible);
	if(visibleElements.length === 0) return true;
	const checked = visibleElements.find(e => e.checked);
	if(checked) return true;
	document.getElementById(`${name}_error`).style.display = 'block';
	return false;
}

const validatePersonalData = function() {
	
	let validationPassed = true;

	// Personal data validation
    const requiredInputs = document.querySelectorAll('.checkout_form .required input, .checkout_form .required select');
    requiredInputs.forEach(element => {
        if(isVisible(element) && element.value.trim().length < 1) {
            element.classList.add('validation-failed');
            const parentRequired = element.parentElement.closest('.required');
            if (parentRequired) {
                parentRequired.classList.add('error');
                const errorEmpty = parentRequired.querySelector('.error-empty');
                if (errorEmpty) errorEmpty.style.display = 'block';
            }
            validationPassed = false;
        }
    });

	// Email validation
	const emailPattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
	document.querySelectorAll('.checkout_form input.email-validate').forEach(input => {
		if (input.value.length > 0 && !emailPattern.test(input.value)) {
			input.classList.add('validation-failed');
			const parent = input.parentElement;
			parent.classList.add('error');
			const errorEmail = parent.querySelector('.error-email');
			if (errorEmail) errorEmail.style.display = 'block';
			validationPassed = false;
		}
	});

	// Phone validation
	document.querySelectorAll('.checkout_form input.phone-validate').forEach(input => {
		if (input.value.length > 0 && input.value.replace(/\D/g, '').length < 3) {
			input.classList.add('validation-failed');
			const parent = input.parentElement;
			parent.classList.add('error');
			const errorPhone = parent.querySelector('.error-phone');
			if (errorPhone) errorPhone.style.display = 'block';
			validationPassed = false;
		}
	});

	// Shipping validation
	
	if(!validateRadios('shipping')) validationPassed = false;
	if(!validateRadios('payment_method')) validationPassed = false;
	

	// Agreement validation
	if (document.getElementById('i_agree') && document.getElementById('i_agree').checked === false) {
		document.getElementById('i_agree_error').style.display = 'block';
		validationPassed = false;
	}

	// Password validation
	const passForm = document.getElementById('pass-form');
	if (passForm && passForm.querySelector('[name=password]').offsetParent !== null) {
		const password = passForm.querySelector('[name=password]').value;
		if (!password) {
			passForm.querySelector('.error-empty').style.display = 'block';
			validationPassed = false;
		}
		const confirmPassword = passForm.querySelector('[name=password-confirm]').value;
		if (password !== confirmPassword) {
			passForm.querySelector('.error-not-match').style.display = 'block';
			validationPassed = false;
		}
	}

	return validationPassed;
};

const initFields = function() {
	const countrySelect = document.getElementById('country-select');
	const regionSelectWraps = document.querySelectorAll('.region-select-wrap');
	const regionSelects = document.querySelectorAll('select.region-select');
	const paymentMethodInputs = document.querySelectorAll('[name=payment_method]');
	const createAccountCheckbox = document.querySelector('[name=create_account]');
	const checkoutFormInputs = document.querySelectorAll('.checkout_form input, .checkout_form select');

	const updateRegions = function() {
		const selectedCountry = this.value;
		regionSelects.forEach(select => {
			const options = select.querySelectorAll('option');
			options.forEach(option => option.style.display = 'none');
			const countryOptions = select.querySelectorAll(`option.country-${selectedCountry}`);
			countryOptions.forEach(option => option.style.display = 'block');
		});
		
		regionSelectWraps.forEach(wrap => wrap.style.display = 'block');
		regionSelects.forEach(select => {
			if(Array.from(select.querySelectorAll('option')).filter(isVisible).length === 0)
				select.closest('.region-select-wrap').style.display = 'none';
		});
	};

	// Add event listeners for country select
	countrySelect.addEventListener('change', updateRegions);
	countrySelect.addEventListener('click', updateRegions);
	countrySelect.addEventListener('keyup', updateRegions);
	updateRegions.call(countrySelect); // Initial call to update regions based on default value

	// Hide validation alerts on corresponding input change
	checkoutFormInputs.forEach(input => {
		input.addEventListener('change', function() {
			this.classList.remove('validation-failed');
			let parentRequired = this.parentElement.closest('.required');
			if(!parentRequired) parentRequired = this.parentElement;
			parentRequired.classList.remove('error');
			const errorMessages = parentRequired.querySelectorAll('.error-empty, .error-email, .error-phone, .text-danger');
			errorMessages.forEach(error => error.style.display = 'none');
		});
	});

	// Handle payment method selection
	paymentMethodInputs.forEach(input => {
		input.addEventListener('click', function() {
			document.getElementById('payment_method_error').style.display = 'none';
			document.querySelectorAll('.payment_method_form').forEach(form => form.style.display = 'none');
			const selectedPaymentForm = document.getElementById('payment_method_form-' + this.value);
			if (selectedPaymentForm) {
				selectedPaymentForm.style.display = 'block';
			}
		});
	});

	// Handle create account checkbox
	if (createAccountCheckbox) {
		createAccountCheckbox.addEventListener('click', function() {
			const passForm = document.getElementById('pass-form');
			passForm.style.display = this.checked ? 'block' : 'none';
		});
	}
};

let formSubmitted = false;
const sendData = async function(enableRecaptcha) {
	const submitBtn = document.querySelector('#submit-order');
	
	try {
		
		if(formSubmitted)
			throw new Error("already submitted");
		
		if(!validatePersonalData())
			throw new Error("personal data is invalid");
		
		submitBtn.classList.add('loading');
		formSubmitted = true;
		
		let formData = new URLSearchParams();
		document.querySelectorAll('form.checkout_form').forEach(form => {
			const formElements = new FormData(form);
			for (const [key, value] of formElements.entries()) {
				formData.append(key, value);
			}
		});
		
		const form = document.querySelector('form.checkout_form');
		
		if(enableRecaptcha)
		{
			const token = await executeCaptcha('CHECKOUT');
			
			if(!token)
			{
				alert("recaptcha validation error");
				throw new Error("recaptcha validation error", token);
			}
			
			formData.append('g-recaptcha-response', token);
		}
		
		const response = await fetch(form.getAttribute('action'), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: formData.toString(),
		});
		
		if(!response.ok)
			throw new Error('Network response was not ok');
		
		const ret = await response.json();
		
		if(!ret)
			throw new Error('result was empty or not a valid json');
		
		if(ret.error)
		{
			if(ret.error_message)
				alert(ret.error_message);
			console.log(ret);
			throw new Error('result was an error');
		}
		
		if(ret.redirect)
		{
			window.onbeforeunload = null;
			location.href = ret.redirect;
		}
		else
		{
			alert('Order created successfully, but no redirect link found'); // this is special event, also can't be seen by regular users
		}
	}
	catch(e)
	{
		console.log('submit error:', e);
	}
	finally
	{
		formSubmitted = false;
		submitBtn.classList.remove('loading');
	}
}

const initCountrySelect = function(regions) {
	const countrySelect = document.getElementById('country-select');
	const regionSelect = document.getElementById('region-select');
	const regionSelectWrap = document.getElementById('region-select-wrap');
	const countryRegionWrap = document.getElementById('country-region-wrap');

	const updateRegions = function() {
		const selectedCountry = this.value;
		const regionOptions = regionSelect.querySelectorAll('option');
		
		// Remove existing region options that are not blank
		regionOptions.forEach(option => {
			if (option.value !== '') {
				option.remove();
			}
		});

		const regionsList = regions[selectedCountry];
		if (regionsList && regionsList.length > 0) {
			regionsList.forEach(region => {
				const option = document.createElement('option');
				option.value = region.id;
				option.textContent = region.name;
				regionSelect.appendChild(option);
			});

			regionSelect.value = '';
			regionSelect.required = true;
			regionSelect.classList.add('required');
			Array.from(regionSelectWrap.children).forEach(child => child.classList.add('required'));

			regionSelectWrap.style.display = 'block';
			Array.from(countryRegionWrap.children).forEach(child => {
				child.classList.remove('col-sm-6');
				child.classList.add('col-sm-4');
			});
		} else {
			// Remove existing region options that are not blank
			regionOptions.forEach(option => {
				if (option.value !== '') {
					option.remove();
				}
			});
			regionSelect.required = false;
			regionSelect.classList.remove('required');
			Array.from(regionSelectWrap.children).forEach(child => child.classList.remove('required'));

			regionSelectWrap.style.display = 'none';
			Array.from(countryRegionWrap.children).forEach(child => {
				child.classList.remove('col-sm-4');
				child.classList.add('col-sm-6');
			});
		}
	};

	// Attach event listeners for change, click, and keyup events
	countrySelect.addEventListener('change', updateRegions);
	countrySelect.addEventListener('click', updateRegions);
	countrySelect.addEventListener('keyup', updateRegions);
	updateRegions.call(countrySelect); // Initial call to update regions based on default value
};


export default async function initCheckoutForm(cfg)
{
	if(cfg.enableRecaptcha)
		await initCaptcha().catch(e => {
			console.log("initCaptcha error", e);
			cfg.captchaError = true;
		});
	
	initFields();
	initCountrySelect(cfg.regions || {});
	
	document.querySelector('#submit-order').addEventListener('click', e => {
		e.preventDefault();
		sendData(!!cfg.enableRecaptcha);
	});
	
	document.querySelectorAll('form.checkout_form').forEach(form => form.addEventListener('submit', e => {
		e.preventDefault();
		sendData(!!cfg.enableRecaptcha);
	}));
};
